var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var GICV2 = function (props) { return (React.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_385_1195)" },
        React.createElement("path", { d: "M8 12C4.691 12 2 9.309 2 6C2 2.691 4.691 0 8 0C11.309 0 14 2.691 14 6C14 9.309 11.309 12 8 12ZM18.456 23.974L17.852 23.672C16.713 23.103 12.999 20.968 12.999 17.4V13.974C12.999 12.894 13.687 11.941 14.713 11.601L18.499 10.346L22.285 11.601C23.31 11.941 23.999 12.894 23.999 13.974V17.4C23.999 21.43 20.235 23.258 19.082 23.722L18.456 23.974ZM11 17.4V14.001H5C2.243 14.001 0 16.244 0 19.001V24.001H14.652C12.921 22.65 11 20.462 11 17.4Z", fill: "#7672F7" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_385_1195" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" }))))); };
export default GICV2;
//# sourceMappingURL=GICV2.js.map